/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_DownloadInputs */

const da_forside_example_download = /** @type {(inputs: Forside_Example_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hent`)
};

/** @type {(inputs: Forside_Example_DownloadInputs) => LocalizedString} */
const en_forside_example_download = da_forside_example_download;

/**

* @param {Forside_Example_DownloadInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_download = /** @type {((inputs?: Forside_Example_DownloadInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_DownloadInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_download(inputs)
	return /** @type {LocalizedString} */ ("Hent")
});